import { render, staticRenderFns } from "./TiptapToolbarBlockMenu.vue?vue&type=template&id=bc354150&scoped=true"
import script from "./TiptapToolbarBlockMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./TiptapToolbarBlockMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TiptapToolbarBlockMenu.vue?vue&type=style&index=0&id=bc354150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc354150",
  null
  
)

export default component.exports